/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CreateEmploymentRequest} from '@cash-web/protos/squareup/roster/mds.pb'
import {CreateEmploymentResponse} from '@cash-web/protos/squareup/roster/mds.pb'


export const createEmployment = (request: CreateEmploymentRequest, options?: CashRequestOptions) => post<CreateEmploymentRequest, CreateEmploymentResponse>("/2.0/cash/create-employment", request, {...options, rejectOnError: true })